import React from "react";
import {
  newContactPath,
  postsPath,
  privacyPolicyPath,
  studyGroupsPath,
  termsOfServicePath,
} from "../../../../../routes";
import { Box, BoxProps, Divider, Link, VStack, Text, Flex } from "@chakra-ui/react";

import Logo from "../../../svg/logo-white.svg";

const Footer = (props: BoxProps) => {
  return (
    <Box
      position="relative"
      zIndex={1}
      bg="brand.500"
      color="white"
      px={{ base: 6, md: 10 }}
      py={{ base: 5, md: 7 }}
      {...props}
    >
      <VStack spacing={8} align="stretch">
        <Flex
          direction={{ base: "column", md: "row" }}
          justify="space-between"
          align={{ base: "center", md: "flex-start" }}
          gap={{ base: 3, md: 8 }}
        >
          <VStack align={{ base: "center", md: "flex-start" }} spacing={3}>
            <Box as="img" src={Logo} alt="A-Loop" h={{ base: "36px", md: "48px" }} w={{ base: "132px", md: "176px" }} />
            <Text textAlign={{ base: "center", md: "left" }} pl={{ base: 0, md: 1 }}>
              建築士のためのコミュニティ
            </Text>
          </VStack>

          <Flex direction={{ base: "column", md: "row" }} align="flex-start" pt={4} gap={{ base: 7, md: 14 }}>
            <VStack align="flex-start" spacing={3}>
              <Text fontSize="xs" fontWeight="bold" letterSpacing="1.2px" color="white">
                サービス
              </Text>
              <VStack align="flex-start" spacing={2} pl={0.5}>
                <Link
                  href={postsPath()}
                  fontSize="sm"
                  color="brand.50"
                  textDecor="none"
                  _hover={{ textDecor: "underline" }}
                  target="_blank"
                  rel="noreferrer"
                >
                  Q&Aコミュニティ
                </Link>
                <Link
                  href={studyGroupsPath()}
                  fontSize="sm"
                  color="brand.50"
                  textDecor="none"
                  _hover={{ textDecor: "underline" }}
                  target="_blank"
                  rel="noreferrer"
                >
                  勉強会
                </Link>
                <Link
                  href={newContactPath()}
                  fontSize="sm"
                  color="brand.50"
                  textDecor="none"
                  _hover={{ textDecor: "underline" }}
                  target="_blank"
                  rel="noreferrer"
                >
                  お問い合わせ
                </Link>
              </VStack>
            </VStack>

            <VStack align="flex-start" spacing={3}>
              <Text fontSize="xs" fontWeight="bold" letterSpacing="1.2px" color="white">
                関連リンク
              </Text>
              <VStack align="flex-start" spacing={2} pl={0.5}>
                <Link
                  href={privacyPolicyPath()}
                  fontSize="sm"
                  color="brand.50"
                  textDecor="none"
                  target="_blank"
                  _hover={{ textDecor: "underline" }}
                >
                  個人情報保護方針
                </Link>
                <Link
                  href={termsOfServicePath()}
                  fontSize="sm"
                  color="brand.50"
                  textDecor="none"
                  target="_blank"
                  _hover={{ textDecor: "underline" }}
                >
                  利用規約
                </Link>
                <Link
                  href="https://a-worker.com/?utm_source=web&utm_medium=altop&utm_campaign=202505"
                  fontSize="sm"
                  color="brand.50"
                  textDecor="none"
                  _hover={{ textDecor: "underline" }}
                  target="_blank"
                  rel="noreferrer"
                >
                  建築設計者のための求人サイト A-worker
                </Link>
              </VStack>
            </VStack>
          </Flex>
        </Flex>

        <VStack spacing={5} align="stretch">
          <Divider borderColor="brand.300" />
          <Flex justify="center" align="center">
            <Flex
              direction={{ base: "column", md: "row" }}
              align="center"
              gap={{ base: 0, md: 1 }}
              as="a"
              href="https://www.unions.co.jp/company/"
              target="_blank"
              rel="noreferrer"
              textDecor="none"
              _hover={{ textDecor: "underline" }}
            >
              <Text fontSize="xs" color="brand.100" textAlign="center">
                運営会社：ユニオンシステム株式会社
              </Text>
              <Text fontSize="xs" color="brand.100" textAlign="center">
                ⒸUNION SYSTEM Inc. All rights reserved.
              </Text>
            </Flex>
          </Flex>
        </VStack>
      </VStack>
    </Box>
  );
};

export default Footer;
